// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cMfrTovdRfBBXhlD7wtI {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

/* BL-19: CSS replacements for framer-motion enter animations.
   Exit animations are intentionally dropped (unmount is instant);
   enter parity: fade 0.18s + pop scale 0.95->1. */
@keyframes kRmmn9fyQdornB_HG9Fd {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes mi9ilDHGqqSKHEOBH8C8 {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.JPEjSO5z7WoOa3i0H4nG {
  animation: kRmmn9fyQdornB_HG9Fd 0.18s ease-out;
}

.howw_hqTxfSuSGjYHIb7 {
  animation: mi9ilDHGqqSKHEOBH8C8 0.18s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .JPEjSO5z7WoOa3i0H4nG,
  .howw_hqTxfSuSGjYHIb7 {
    animation: none;
  }
}

.tT2ETF455ipUlJYlzGZU {
  background: var(--modal-bg, #ffffff);
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wgJrpKpfOmqdKi1yLnr5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color, #e8e8e8);
}

.J_8tsb8YhDqP516_nAVY {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
}

.cYkQPM443siaEpJF6M0n {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bwpVV5eKes2HmKVJg1wa {
  padding: 8px 16px;
  background: var(--primary-color, #1890ff);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.bwpVV5eKes2HmKVJg1wa:hover {
  background: var(--primary-hover, #096dd9);
}

.r0ZX3ua_B4kztw65OZJ8 {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  font-size: 24px;
  color: var(--text-secondary, #8c8c8c);
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.r0ZX3ua_B4kztw65OZJ8:hover {
  background: var(--hover-bg, #f5f5f5);
  color: var(--text-primary, #1a1a1a);
}

.WsqOz96bqd2M5P_JRh3t {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color, #e8e8e8);
  flex-wrap: wrap;
}

.k3wnk6IxieBJNVTa4dFb {
  display: flex;
  align-items: center;
  gap: 8px;
}

.A0N4u7rPVUd4a1Y0op7O {
  font-size: 13px;
  color: var(--text-secondary, #8c8c8c);
  white-space: nowrap;
}

.tuiNjXdpZEj2lXTIIqQX {
  width: 60px;
  padding: 6px 10px;
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 6px;
  font-size: 14px;
  background: var(--input-bg, #ffffff);
  color: var(--text-primary, #1a1a1a);
}

.tuiNjXdpZEj2lXTIIqQX:focus {
  outline: none;
  border-color: var(--primary-color, #1890ff);
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.QgSynuzqvJcYIYG1kjiz {
  padding: 6px 12px;
  background: var(--button-bg, #f5f5f5);
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 6px;
  font-size: 13px;
  color: var(--text-primary, #1a1a1a);
  cursor: pointer;
  transition: all 0.2s ease;
}

.QgSynuzqvJcYIYG1kjiz:hover {
  background: var(--button-hover, #e8e8e8);
  border-color: var(--primary-color, #1890ff);
}

.vEzIyjArUobSu6Yz5vpH {
  flex: 1;
  overflow: auto;
  padding: 24px;
  min-height: 300px;
}

.fxPhcluqK0iIglHPKhhz {
  display: grid;
  gap: 4px;
  width: 100%;
  height: 100%;
  min-height: 300px;
  background: var(--grid-bg, #f0f0f0);
  border-radius: 8px;
  padding: 8px;
}

.IKSgi0L5W4r7PrYLAzqc {
  position: relative;
  background: var(--slot-bg, #ffffff);
  border-radius: 6px;
  border: 1px solid var(--slot-border, #e8e8e8);
  overflow: hidden;
  transition: all 0.2s ease;
}

/* BL-19: replaces whileHover={{ scale: 1.02, zIndex: 10 }} */
.IKSgi0L5W4r7PrYLAzqc:hover {
  border-color: var(--primary-color, #1890ff);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
  z-index: 10;
}

/* BL-19: replaces whileTap={{ scale: 0.98 }} */
.IKSgi0L5W4r7PrYLAzqc:active {
  transform: scale(0.98);
}

.IKSgi0L5W4r7PrYLAzqc.s5dtXrGne4VKoiUkftKZ {
  border-color: var(--primary-color, #1890ff);
  box-shadow: 0 0 0 2px var(--primary-color, #1890ff), 0 4px 12px rgba(0, 0, 0, 0.1);
}

.AJbiBRVqsHYdktEzFPSQ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 12px;
  text-align: center;
}

.HkuvDDsIsb85xxJ0nwC5 {
  font-weight: 600;
  font-size: 14px;
  color: var(--text-primary, #1a1a1a);
}

.b8lgCK8END3qj03zhubP {
  font-size: 12px;
  color: var(--text-secondary, #8c8c8c);
  margin-top: 4px;
}

.DvtdomDQZK2fpK5I3_uw {
  position: absolute;
  background: var(--primary-color, #1890ff);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.IKSgi0L5W4r7PrYLAzqc:hover .DvtdomDQZK2fpK5I3_uw {
  opacity: 1;
}

.ozDnu1U6xQaO0xnVshe0,
.by3wBqyQMworIdypibBN {
  left: 0;
  right: 0;
  height: 4px;
}

.ozDnu1U6xQaO0xnVshe0 {
  top: -2px;
  cursor: ns-resize;
}

.by3wBqyQMworIdypibBN {
  bottom: -2px;
  cursor: ns-resize;
}

.m_MbMtOZETAvZqQkCFgZ,
.fKiFLNWtPQpuMWtSieRj {
  top: 0;
  bottom: 0;
  width: 4px;
}

.m_MbMtOZETAvZqQkCFgZ {
  left: -2px;
  cursor: ew-resize;
}

.fKiFLNWtPQpuMWtSieRj {
  right: -2px;
  cursor: ew-resize;
}

.WYcdhLRHaCg6teQdkq0N {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.IKSgi0L5W4r7PrYLAzqc:hover .WYcdhLRHaCg6teQdkq0N {
  opacity: 1;
}

._98gDvZpGAmc3gPd_JLK6 {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color, #1890ff);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

._98gDvZpGAmc3gPd_JLK6:hover {
  background: var(--primary-hover, #096dd9);
  transform: scale(1.1);
}

._98gDvZpGAmc3gPd_JLK6:active {
  transform: scale(0.95);
}

/* Preset Modal */
.ReUsvOS68zpz5Nwt63qL {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.nKVEnwmLIafrUA8tL36e {
  background: var(--modal-bg, #ffffff);
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.nKVEnwmLIafrUA8tL36e h3 {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
}

.LlF2caYFfudO2oDS5bYr {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 6px;
  font-size: 14px;
  background: var(--input-bg, #ffffff);
  color: var(--text-primary, #1a1a1a);
  box-sizing: border-box;
  margin-bottom: 16px;
}

.LlF2caYFfudO2oDS5bYr:focus {
  outline: none;
  border-color: var(--primary-color, #1890ff);
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.Zg46j8eirY1EE38oJLEI {
  margin: -8px 0 12px;
  font-size: 13px;
  color: var(--error-color, #cf1322);
}

/* P0: vùng liệt kê preset đã lưu (trước đây lưu được nhưng không hiện ở đâu cả). */
.kDEvzwQV3Ly4r0IzRzMA {
  font-size: 12px;
  opacity: 0.7;
}

.aJhFk_Bqtr1Jr1W3ARqw {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 999px;
  padding: 0 2px 0 0;
}

.mjKyRGBtMGrPHcx16h_3 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.Y_rHBFhETi9zTDpHNqEt {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 6px;
  font-size: 14px;
  color: var(--text-primary, #1a1a1a);
  cursor: pointer;
  transition: all 0.2s ease;
}

.Y_rHBFhETi9zTDpHNqEt:hover {
  background: var(--hover-bg, #f5f5f5);
  border-color: var(--primary-color, #1890ff);
}

.W7d4IRKiT1krFqMJljtD {
  padding: 8px 16px;
  background: var(--primary-color, #1890ff);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.W7d4IRKiT1krFqMJljtD:hover {
  background: var(--primary-hover, #096dd9);
}

/* Dark theme support */
[data-chart-mode="dark"] .tT2ETF455ipUlJYlzGZU,
[data-chart-mode="dark"] .nKVEnwmLIafrUA8tL36e {
  background: var(--modal-bg-dark, #1e1e1e);
}

[data-chart-mode="dark"] .wgJrpKpfOmqdKi1yLnr5,
[data-chart-mode="dark"] .WsqOz96bqd2M5P_JRh3t {
  border-color: var(--border-color-dark, #434343);
}

[data-chart-mode="dark"] .IKSgi0L5W4r7PrYLAzqc {
  background: var(--slot-bg-dark, #2a2a2a);
  border-color: var(--slot-border-dark, #434343);
}

[data-chart-mode="dark"] .IKSgi0L5W4r7PrYLAzqc:hover {
  border-color: var(--primary-color-dark, #177ddc);
}

[data-chart-mode="dark"] .tuiNjXdpZEj2lXTIIqQX,
[data-chart-mode="dark"] .LlF2caYFfudO2oDS5bYr {
  background: var(--input-bg-dark, #2a2a2a);
  border-color: var(--border-color-dark, #434343);
  color: var(--text-primary-dark, #ffffff);
}

[data-chart-mode="dark"] .QgSynuzqvJcYIYG1kjiz {
  background: var(--button-bg-dark, #2a2a2a);
  border-color: var(--border-color-dark, #434343);
  color: var(--text-primary-dark, #ffffff);
}

[data-chart-mode="dark"] .QgSynuzqvJcYIYG1kjiz:hover {
  background: var(--button-hover-dark, #3a3a3a);
}

[data-chart-mode="dark"] .fxPhcluqK0iIglHPKhhz {
  background: var(--grid-bg-dark, #1a1a1a);
}

[data-chart-mode="dark"] .Y_rHBFhETi9zTDpHNqEt {
  border-color: var(--border-color-dark, #434343);
  color: var(--text-primary-dark, #ffffff);
}

[data-chart-mode="dark"] .Y_rHBFhETi9zTDpHNqEt:hover {
  background: var(--hover-bg-dark, #3a3a3a);
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .IKSgi0L5W4r7PrYLAzqc.s5dtXrGne4VKoiUkftKZ {
    border-width: 3px;
  }
  
  .DvtdomDQZK2fpK5I3_uw {
    opacity: 1;
  }
  
  .WYcdhLRHaCg6teQdkq0N {
    opacity: 1;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .IKSgi0L5W4r7PrYLAzqc,
  .DvtdomDQZK2fpK5I3_uw,
  ._98gDvZpGAmc3gPd_JLK6,
  .tT2ETF455ipUlJYlzGZU,
  .nKVEnwmLIafrUA8tL36e {
    transition: none;
    animation: none;
  }
}

/* Focus styles for accessibility */
.IKSgi0L5W4r7PrYLAzqc:focus-within {
  outline: 2px solid var(--primary-color, #1890ff);
  outline-offset: -2px;
}

.bwpVV5eKes2HmKVJg1wa:focus,
.QgSynuzqvJcYIYG1kjiz:focus,
.r0ZX3ua_B4kztw65OZJ8:focus,
._98gDvZpGAmc3gPd_JLK6:focus,
.Y_rHBFhETi9zTDpHNqEt:focus,
.W7d4IRKiT1krFqMJljtD:focus {
  outline: 2px solid var(--primary-color, #1890ff);
  outline-offset: 2px;
}

.tuiNjXdpZEj2lXTIIqQX:focus,
.LlF2caYFfudO2oDS5bYr:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/widget/components/LayoutDesigner.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;;kDAEkD;AAClD;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,8CAAkC;AACpC;;AAEA;EACE,8CAAiC;AACnC;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA,mFAAmF;AACnF;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;EAC9C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,yCAAyC;EACzC,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;;IAKE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;;;;;;EAME,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n/* BL-19: CSS replacements for framer-motion enter animations.\r\n   Exit animations are intentionally dropped (unmount is instant);\r\n   enter parity: fade 0.18s + pop scale 0.95->1. */\r\n@keyframes ldFadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes ldPopIn {\r\n  from { opacity: 0; transform: scale(0.95); }\r\n  to { opacity: 1; transform: scale(1); }\r\n}\r\n\r\n.animFadeIn {\r\n  animation: ldFadeIn 0.18s ease-out;\r\n}\r\n\r\n.animPopIn {\r\n  animation: ldPopIn 0.18s ease-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .animFadeIn,\r\n  .animPopIn {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n.modal {\r\n  background: var(--modal-bg, #ffffff);\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\r\n  width: 100%;\r\n  max-width: 900px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid var(--border-color, #e8e8e8);\r\n}\r\n\r\n.title {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--text-primary, #1a1a1a);\r\n}\r\n\r\n.headerActions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.presetButton {\r\n  padding: 8px 16px;\r\n  background: var(--primary-color, #1890ff);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.presetButton:hover {\r\n  background: var(--primary-hover, #096dd9);\r\n}\r\n\r\n.closeButton {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 24px;\r\n  color: var(--text-secondary, #8c8c8c);\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.closeButton:hover {\r\n  background: var(--hover-bg, #f5f5f5);\r\n  color: var(--text-primary, #1a1a1a);\r\n}\r\n\r\n.toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid var(--border-color, #e8e8e8);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.toolbarGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.toolbarLabel {\r\n  font-size: 13px;\r\n  color: var(--text-secondary, #8c8c8c);\r\n  white-space: nowrap;\r\n}\r\n\r\n.toolbarInput {\r\n  width: 60px;\r\n  padding: 6px 10px;\r\n  border: 1px solid var(--border-color, #d9d9d9);\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  background: var(--input-bg, #ffffff);\r\n  color: var(--text-primary, #1a1a1a);\r\n}\r\n\r\n.toolbarInput:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color, #1890ff);\r\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\r\n}\r\n\r\n.actionButton {\r\n  padding: 6px 12px;\r\n  background: var(--button-bg, #f5f5f5);\r\n  border: 1px solid var(--border-color, #d9d9d9);\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  color: var(--text-primary, #1a1a1a);\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.actionButton:hover {\r\n  background: var(--button-hover, #e8e8e8);\r\n  border-color: var(--primary-color, #1890ff);\r\n}\r\n\r\n.gridPreview {\r\n  flex: 1;\r\n  overflow: auto;\r\n  padding: 24px;\r\n  min-height: 300px;\r\n}\r\n\r\n.gridContainer {\r\n  display: grid;\r\n  gap: 4px;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 300px;\r\n  background: var(--grid-bg, #f0f0f0);\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n}\r\n\r\n.slot {\r\n  position: relative;\r\n  background: var(--slot-bg, #ffffff);\r\n  border-radius: 6px;\r\n  border: 1px solid var(--slot-border, #e8e8e8);\r\n  overflow: hidden;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n/* BL-19: replaces whileHover={{ scale: 1.02, zIndex: 10 }} */\r\n.slot:hover {\r\n  border-color: var(--primary-color, #1890ff);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  transform: scale(1.02);\r\n  z-index: 10;\r\n}\r\n\r\n/* BL-19: replaces whileTap={{ scale: 0.98 }} */\r\n.slot:active {\r\n  transform: scale(0.98);\r\n}\r\n\r\n.slot.selected {\r\n  border-color: var(--primary-color, #1890ff);\r\n  box-shadow: 0 0 0 2px var(--primary-color, #1890ff), 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.slotContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  padding: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.slotSymbol {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--text-primary, #1a1a1a);\r\n}\r\n\r\n.slotTimeframe {\r\n  font-size: 12px;\r\n  color: var(--text-secondary, #8c8c8c);\r\n  margin-top: 4px;\r\n}\r\n\r\n.resizeHandle {\r\n  position: absolute;\r\n  background: var(--primary-color, #1890ff);\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n  z-index: 10;\r\n}\r\n\r\n.slot:hover .resizeHandle {\r\n  opacity: 1;\r\n}\r\n\r\n.resizeTop,\r\n.resizeBottom {\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n}\r\n\r\n.resizeTop {\r\n  top: -2px;\r\n  cursor: ns-resize;\r\n}\r\n\r\n.resizeBottom {\r\n  bottom: -2px;\r\n  cursor: ns-resize;\r\n}\r\n\r\n.resizeLeft,\r\n.resizeRight {\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 4px;\r\n}\r\n\r\n.resizeLeft {\r\n  left: -2px;\r\n  cursor: ew-resize;\r\n}\r\n\r\n.resizeRight {\r\n  right: -2px;\r\n  cursor: ew-resize;\r\n}\r\n\r\n.splitButtons {\r\n  position: absolute;\r\n  bottom: 8px;\r\n  right: 8px;\r\n  display: flex;\r\n  gap: 4px;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.slot:hover .splitButtons {\r\n  opacity: 1;\r\n}\r\n\r\n.splitButton {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--primary-color, #1890ff);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, transform 0.1s ease;\r\n}\r\n\r\n.splitButton:hover {\r\n  background: var(--primary-hover, #096dd9);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.splitButton:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n/* Preset Modal */\r\n.presetModalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1100;\r\n}\r\n\r\n.presetModal {\r\n  background: var(--modal-bg, #ffffff);\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.presetModal h3 {\r\n  margin: 0 0 16px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--text-primary, #1a1a1a);\r\n}\r\n\r\n.presetInput {\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  border: 1px solid var(--border-color, #d9d9d9);\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  background: var(--input-bg, #ffffff);\r\n  color: var(--text-primary, #1a1a1a);\r\n  box-sizing: border-box;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.presetInput:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color, #1890ff);\r\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\r\n}\r\n\r\n.presetError {\r\n  margin: -8px 0 12px;\r\n  font-size: 13px;\r\n  color: var(--error-color, #cf1322);\r\n}\r\n\r\n/* P0: vùng liệt kê preset đã lưu (trước đây lưu được nhưng không hiện ở đâu cả). */\r\n.savedPresetsLabel {\r\n  font-size: 12px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.savedPresetChip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  border: 1px solid var(--border-color, #d9d9d9);\r\n  border-radius: 999px;\r\n  padding: 0 2px 0 0;\r\n}\r\n\r\n.presetActions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n}\r\n\r\n.cancelButton {\r\n  padding: 8px 16px;\r\n  background: transparent;\r\n  border: 1px solid var(--border-color, #d9d9d9);\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  color: var(--text-primary, #1a1a1a);\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background: var(--hover-bg, #f5f5f5);\r\n  border-color: var(--primary-color, #1890ff);\r\n}\r\n\r\n.saveButton {\r\n  padding: 8px 16px;\r\n  background: var(--primary-color, #1890ff);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.saveButton:hover {\r\n  background: var(--primary-hover, #096dd9);\r\n}\r\n\r\n/* Dark theme support */\r\n[data-chart-mode=\"dark\"] .modal,\r\n[data-chart-mode=\"dark\"] .presetModal {\r\n  background: var(--modal-bg-dark, #1e1e1e);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .header,\r\n[data-chart-mode=\"dark\"] .toolbar {\r\n  border-color: var(--border-color-dark, #434343);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .slot {\r\n  background: var(--slot-bg-dark, #2a2a2a);\r\n  border-color: var(--slot-border-dark, #434343);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .slot:hover {\r\n  border-color: var(--primary-color-dark, #177ddc);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .toolbarInput,\r\n[data-chart-mode=\"dark\"] .presetInput {\r\n  background: var(--input-bg-dark, #2a2a2a);\r\n  border-color: var(--border-color-dark, #434343);\r\n  color: var(--text-primary-dark, #ffffff);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .actionButton {\r\n  background: var(--button-bg-dark, #2a2a2a);\r\n  border-color: var(--border-color-dark, #434343);\r\n  color: var(--text-primary-dark, #ffffff);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .actionButton:hover {\r\n  background: var(--button-hover-dark, #3a3a3a);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .gridContainer {\r\n  background: var(--grid-bg-dark, #1a1a1a);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .cancelButton {\r\n  border-color: var(--border-color-dark, #434343);\r\n  color: var(--text-primary-dark, #ffffff);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .cancelButton:hover {\r\n  background: var(--hover-bg-dark, #3a3a3a);\r\n}\r\n\r\n/* High contrast mode */\r\n@media (prefers-contrast: high) {\r\n  .slot.selected {\r\n    border-width: 3px;\r\n  }\r\n  \r\n  .resizeHandle {\r\n    opacity: 1;\r\n  }\r\n  \r\n  .splitButtons {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Reduced motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .slot,\r\n  .resizeHandle,\r\n  .splitButton,\r\n  .modal,\r\n  .presetModal {\r\n    transition: none;\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* Focus styles for accessibility */\r\n.slot:focus-within {\r\n  outline: 2px solid var(--primary-color, #1890ff);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.presetButton:focus,\r\n.actionButton:focus,\r\n.closeButton:focus,\r\n.splitButton:focus,\r\n.cancelButton:focus,\r\n.saveButton:focus {\r\n  outline: 2px solid var(--primary-color, #1890ff);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.toolbarInput:focus,\r\n.presetInput:focus {\r\n  outline: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `cMfrTovdRfBBXhlD7wtI`,
	"animFadeIn": `JPEjSO5z7WoOa3i0H4nG`,
	"ldFadeIn": `kRmmn9fyQdornB_HG9Fd`,
	"animPopIn": `howw_hqTxfSuSGjYHIb7`,
	"ldPopIn": `mi9ilDHGqqSKHEOBH8C8`,
	"modal": `tT2ETF455ipUlJYlzGZU`,
	"header": `wgJrpKpfOmqdKi1yLnr5`,
	"title": `J_8tsb8YhDqP516_nAVY`,
	"headerActions": `cYkQPM443siaEpJF6M0n`,
	"presetButton": `bwpVV5eKes2HmKVJg1wa`,
	"closeButton": `r0ZX3ua_B4kztw65OZJ8`,
	"toolbar": `WsqOz96bqd2M5P_JRh3t`,
	"toolbarGroup": `k3wnk6IxieBJNVTa4dFb`,
	"toolbarLabel": `A0N4u7rPVUd4a1Y0op7O`,
	"toolbarInput": `tuiNjXdpZEj2lXTIIqQX`,
	"actionButton": `QgSynuzqvJcYIYG1kjiz`,
	"gridPreview": `vEzIyjArUobSu6Yz5vpH`,
	"gridContainer": `fxPhcluqK0iIglHPKhhz`,
	"slot": `IKSgi0L5W4r7PrYLAzqc`,
	"selected": `s5dtXrGne4VKoiUkftKZ`,
	"slotContent": `AJbiBRVqsHYdktEzFPSQ`,
	"slotSymbol": `HkuvDDsIsb85xxJ0nwC5`,
	"slotTimeframe": `b8lgCK8END3qj03zhubP`,
	"resizeHandle": `DvtdomDQZK2fpK5I3_uw`,
	"resizeTop": `ozDnu1U6xQaO0xnVshe0`,
	"resizeBottom": `by3wBqyQMworIdypibBN`,
	"resizeLeft": `m_MbMtOZETAvZqQkCFgZ`,
	"resizeRight": `fKiFLNWtPQpuMWtSieRj`,
	"splitButtons": `WYcdhLRHaCg6teQdkq0N`,
	"splitButton": `_98gDvZpGAmc3gPd_JLK6`,
	"presetModalOverlay": `ReUsvOS68zpz5Nwt63qL`,
	"presetModal": `nKVEnwmLIafrUA8tL36e`,
	"presetInput": `LlF2caYFfudO2oDS5bYr`,
	"presetError": `Zg46j8eirY1EE38oJLEI`,
	"savedPresetsLabel": `kDEvzwQV3Ly4r0IzRzMA`,
	"savedPresetChip": `aJhFk_Bqtr1Jr1W3ARqw`,
	"presetActions": `mjKyRGBtMGrPHcx16h_3`,
	"cancelButton": `Y_rHBFhETi9zTDpHNqEt`,
	"saveButton": `W7d4IRKiT1krFqMJljtD`
};
export default ___CSS_LOADER_EXPORT___;
